import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./utils/apiSlice";
import authReducer from "./utils/authSlice";
import gamificationReducer from "./utils/gamificationSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    gamification: gamificationReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

export default store;
